import { App } from 'vue'
import { dataFinder } from '@/utils/dataFinder'

// 过滤一些无意义的库报错
const filterError = (message: string, filename?: string) => {
  // 过滤第三方库
  const ignorePatterns = [
    'node_modules',
    'chrome-extension://',
    'moz-extension://',
    'lib',
    'vendor',
    'api.here.com',
    'ResizeObserver',
    'here'
  ]

  // 检查 message 或 filename 中是否包含要过滤的模式
  return ignorePatterns.some((pattern) => {
    return message?.includes(pattern) || filename?.includes(pattern)
  })
}

const longErrorStack = (stack: string) => {
  return stack ? stack.substring(0, 1000) : ''
}

// 添加全局错误处理器
const vueComponentErrorHandler = (err: any, instance: any, info: any) => {
  const message = err?.message ?? (typeof err === 'string' ? err : '')
  const stack = err?.stack ?? ''
  dataFinder.collectEvent('web_error_VueComponent', {
    message,
    stack: longErrorStack(stack),
    info
  })
}

// 监听错误上报
const errorHandler = (event: any) => {
  const { message, filename, lineno, colno, error } = event
  // 添加过滤逻辑
  if (filterError(message, filename)) {
    console.log('已过滤第三方库错误:', message, filename)
    return
  }

  dataFinder.collectEvent('web_js_error', {
    message: message,
    filename: filename,
    location: `${lineno}:${colno}`,
    stack: longErrorStack(error?.stack)
  })
}

// 捕获异步报错
const promiseErrorHandler = (event: any) => {
  const { reason, type } = event
  const message = reason?.message ?? (typeof reason === 'string' ? reason : '')
  const stack = reason?.stack ?? ''

  // 修复过滤逻辑，同时检查 stack
  if (filterError(message, stack)) {
    return
  }

  dataFinder.collectEvent('web_js_promise_error', {
    type,
    message,
    stack: longErrorStack(stack)
  })
}

let isInitialized = false
let cleanupFn: () => void = () => {}
export default (app: App) => {
  try {
    // 如果已经初始化，先清理
    if (isInitialized && cleanupFn) {
      cleanupFn()
    }

    app.config.errorHandler = vueComponentErrorHandler
    window.addEventListener('error', errorHandler)
    window.addEventListener('unhandledrejection', promiseErrorHandler)

    isInitialized = true
    cleanupFn = () => {
      window.removeEventListener('error', errorHandler)
      window.removeEventListener('unhandledrejection', promiseErrorHandler)
      isInitialized = false
    }
    return cleanupFn
  } catch (error) {
    console.error('错误报告初始化错误:', error)
  }
}
